import { IModuleProps } from '../../core/utils/modules.tsx';

import routes from './routes.tsx';

export default {
    name: 'property_bills',
    routes,
} as IModuleProps;
